import { decode } from 'html-entities';
import DOMPurify from 'dompurify';
export const sanitize = (value) => DOMPurify.sanitize(value);
export const decodeHtmlEntities = (value) => decode(sanitize(value), { scope: 'strict' });
